import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const subscribe = (data) => axios.post(`${API}/subscribers`, data);
export const submitContact = (data) => axios.post(`${API}/contact`, data);
